import { render, staticRenderFns } from "./Sdk.vue?vue&type=template&id=6fca875d&scoped=true"
import script from "./Sdk.vue?vue&type=script&lang=js"
export * from "./Sdk.vue?vue&type=script&lang=js"
import style0 from "./Sdk.vue?vue&type=style&index=0&id=6fca875d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fca875d",
  null
  
)

export default component.exports